import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Iterable } from 'immutable';
import { SingleSelect } from '@els/els-react--select';

function ResultsPerPage({ resultsPerPage, dropdownValues, setResultsPerPage }) {
  const isCurrentValue = (value) => value === resultsPerPage;
  const [selectedValue, setSelectedValue] = useState(resultsPerPage);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setOptions(() => (dropdownValues && dropdownValues.length > 0 ? dropdownValues.map((item) => item.value) : []));
  }, [dropdownValues]);

  const selectHandler = (value) => {
    isCurrentValue(value);
    if (!isCurrentValue(value)) {
      setResultsPerPage(value);
    }
    setSelectedValue(value);
  };

  return (
    <div className="results-per-wrapper clearfix">
      <div className="results-per-label">Results per page</div>
      <div className="results-per-dropdown">
        {options && options.length > 0 && (
          <SingleSelect
            options={options}
            selectedOptions={[selectedValue]}
            blankOptionLabel={`${selectedValue}`}
            label="Select an option"
            required
            onSelect={(l) => {
              selectHandler(l);
            }}
            size="small"
            shouldHideLabel
            className="u-docs-position-relative u-docs-z-index"
          />
        )}
      </div>
    </div>
  );
}

ResultsPerPage.propTypes = {
  resultsPerPage: PropTypes.number,
  dropdownValues: PropTypes.oneOfType([PropTypes.instanceOf(Iterable), PropTypes.array]).isRequired,
  setResultsPerPage: PropTypes.func.isRequired,
};

export default ResultsPerPage;
